
import { Options, mixins } from "vue-class-component";
import { reactive } from "vue";
import Toaster from "../../helpers/Toaster";
import { useStore, ActionTypes } from "../../store";
import CashierSession from "../../service/CashierSession";
import router from "../../router";
import { numeric, required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import moment from "moment";
import UtilityOptions from "../../mixins/UtilityOptions";
import footerService from "../../service/footerService";

@Options({
  components: {},
  title: "Cashier Session login",
  props: ['footerData']
})
export default class CashierSessionLogin extends mixins(UtilityOptions) {
  private showProgress = false;
  private toast;
  private submitted = false;
  private state = reactive({
    cashBalance: "",
  });
  private footerService;
  private userName = "";
  private branchName = "";

  private rules = {
    cashBalance: {
      required,
      numeric,
    },
  };

  private v$ = useVuelidate(this.rules, this.state);

  created() {
    this.toast = new Toaster();
  }

  mounted() {
    this.footerService = new footerService();
    this.getUserData();

    // focus the balance field
    var firstElement = document.getElementById('cashBalance');
    if(firstElement){
      firstElement.focus();
    }
  }

  getUserData(){
    this.footerService.branchDetail().then((data) => {
      this.userName = data.userName;
      this.branchName = data.branchName;
    });
  }

  authenticate(isFormValid) {
    this.submitted = true;

    if (isFormValid) {
      const cashierSession = new CashierSession();
      const store = useStore();
      this.showProgress = true;

      cashierSession
      .loginCashier(this.state.cashBalance.trim(), "Web")
      .then((res) => {
        if (res.status_id == 1) {
          this.toast.showInfo(res.msg);
          store.dispatch(ActionTypes.CASHIER_SESSION, Date());

          const redirectQuery = this.$route.query.redirect;
          let redirect = "/pos";

          if (typeof redirectQuery === "string") {
            redirect = redirectQuery;
          }

          router.replace({ path: redirect });

        } else {
          this.state.cashBalance = "";
          this.submitted = false;
          this.toast.handleResponse(res);
        }
      })
      .finally(() => {
        this.showProgress = false;
      });
    }

    this.showProgress = false;
  }

  // loadUser(role) {
  //   if (role == "admin") {
  //     this.state.cashBalance = "admin@doc.lk";
  //   }
  // }
}
